import { useState } from "react";
import TransactionServices from "./TransactionServices";
import SuggestedPaymentUploadBox from "components/Payment/SuggestedPaymentUpload";

export default function SuggestedPayment(subEntity: any) {


    const closeModal = (e: any) => {
        const modal = document.getElementById("myModal") as HTMLElement;
        modal?.classList.remove("displayItem");
        modal?.classList.add("displayNoneItem");
        document.body.classList.remove("HiddenoverflowX");
    }

    let [paymentDetail, setPaymentDetail] = useState<any>([]);
    const SearchListing = () => {
        var payLoad = { paymentType: "Contact", showZeroBal: true, crossed: true, uncrossed: true, royalty: true, biannual: 3, quarterly: 2, monthly: 1 }
        TransactionServices.getPaymentDetails(20251231, payLoad).then((res: any) => {
            console.log(res)
            paymentDetail = res
            setPaymentDetail(res)
        })
    }

    let [suggestedPaymentUploadStatus, setSuggestedPaymentUploadStatus] = useState(false);
    const suggestedPaymentUpload = () => {
        suggestedPaymentUploadStatus = true;
        setSuggestedPaymentUploadStatus(suggestedPaymentUploadStatus)
    }

    return (<>

        {(subEntity) && <div id="myModal" className="modal pLarge ws-12 ">

            <a onClick={() => closeModal(true)} className="btn-xxs modalClose borderNone bgTransparent" style={{ position: "inherit" }} href="../../">
                <i className="icon-close3 danger"></i>
            </a>

            <div className="allowHscroll allowVscroll full-height-vh95 ws-12 box landing" style={{ minHeight: "80%" }}>

                <div className="box-header-main">
                    <h2 className="ws-3">Payment Schedule</h2>
                    <div className="ws-8 pull-right mrxl prl">
                        <button className="btn icon-btn edit pull-right width100 height35 " onClick={() => suggestedPaymentUpload()}>Upload</button>
                        <button className="icon-btn primary pull-right width100 height35" title="Download Templates" >Download</button>
                        <button className="icon-btn edit pull-right width200 height35" title="Create Opening Balance">Create Opening Balance</button>
                        <button className="btn icon-btn info pull-right width150 height35" title="Create Snapshot">Create Snapshot</button>
                    </div>
                </div>

                <div className="box-content box">
                    <div className="pull-right mll ws-12 mt">
                        <label className="switch ws-2 mr pull-right">
                            <input type="checkbox" className="checkbox-inline " ng-model="search.payOpeningBalance"></input>
                            <span className="slider round text-left white pm pts" ng-show="search.payOpeningBalance=='1'">Yes</span>
                            <span className="hide slider round text-right white pm pts sliderOff" ng-show="!search.payOpeningBalance =='1'">  ::before  "No"  </span>
                        </label>
                        <div className="pull-right mr">Pay Opening Balance</div>
                    </div>

                    <div className="ws-12 pbl">
                        <div className="ws-3">
                            <label className="control-label">
                                <strong >Period:</strong>
                            </label>
                            <div className="label-entries">
                                <select title="Choose a period" className="optionSpacer ws-10 pm ws-10 m0 heightReset ">
                                    <option value="20140331" className=" btn">
                                        Jan 1, 2014 - Mar 31, 2014
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div className="ws-6 mtl">
                            <div className="ws-7">
                                <div className="pr">
                                    <button className="icon-btn edit pm m0 ws-2 pull right noBorderRadius" onClick={SearchListing}>Search</button>
                                    <input type="text" placeholder="Type to search" className="pm ws-10 heightReset noBorderRadius " />
                                </div>
                            </div>
                        </div>

                        <div className="ws-3 mtl pull-right">
                            <button className="btn-purple pm m0 ws-12" ng-click="commonSearchSliderOpen();"> Advanced Search
                                <i className=" icon-params1 pull-right"> </i>
                            </button>
                        </div>

                    </div>

                    <div className="alert alert-warning ws-12 mt pme" ng-show="resetWarning">  Generate new workspace before you can start working   </div>
                </div>

                <div data-ng-show="totalPayments > 0" className="ws-12 box mtl">

                    <div className="ws-12 well cursor-hand ps mt mb borderRounded">
                        <div className="w-12 pm">
                            <span className="text-bold ws-12 pm text-center">Opening Balance</span>
                            <span className="pm ws-12 text-right ">
                                (239.57)
                                <input type="radio" className="pull-right ws-2" ng-click="changeOpeningTotal()" name="totalBalBT" />
                            </span>
                        </div>
                        <hr className="w-1 divider" />
                        <div className="w-12 pm">
                            <span className="text-bold ws-12 pm text-center">Payments</span>
                            <span className="pm ws-12 text-center ">0.00</span>
                        </div>
                        <hr className="w-1 divider" />
                        <div className="w-12 pm">
                            <span className="text-bold ws-12 pm text-center">Period Balance</span>
                            <span className="pm ws-12 text-center ">0.00</span>
                        </div>
                        <hr className="w-1 divider" />
                        <div className="w-12 pm">
                            <span className="text-bold ws-12 pm text-center">Royalties</span>
                            <span className="pm ws-12 text-center ">0.00</span>
                        </div>
                        <hr className="w-1 divider" />
                        <div className="w-12 pm">
                            <span className="text-bold ws-12 pm text-center">Closing Balance</span>
                            <span className="pm ws-12 text-right ">
                                (239.57)
                                <input type="radio" className="pull-right ws-2" ng-click="changeClosingBalTotal()" name="totalBalBT" />
                            </span>
                        </div>
                        <hr className="w-1 divider" />
                        <div className="w-30 pm">
                            <div className="ws-12">
                                <div className="mt">
                                    <label className="ws-12 text-bold m0 text-left mt mr mb">Payment to Make</label>
                                    <input type="text" readOnly data-ng-model="topTotal" className="text-right text-bold ws-4 mt height35" />
                                </div>
                                <div className="ws-6 mt ml">
                                    <button data-ng-click="saveTopAll()" className="icon-btn info text-right mb height35" ng-hide="saveTopAllLoading">Pay All</button>
                                    <button className="btn-search text-right mb  hide" ng-show="saveTopAllLoading">
                                        <i className="icon-spinner3"></i>
                                    </button>
                                    <div className="icon-btn edit hover-box badge pl pr height35">
                                        Export
                                        <i className="icon-download"> </i>
                                        <div className="hover-block leftHoverBox w-25 rightReset box pm">
                                            <a className="hover-box btn btn-large btn-app icon-btn edit btn-sm ng binding" data-ng-click="popupExportSuggestedPayments(search, 1)">Bulk Payment Export</a>
                                            <a className="hover-box btn btn-large btn-app icon-btn edit btn-sm ng-isolate-scope " data-ng-click="popupExportSuggestedPayments(search)">Export</a>
                                            <a className="hover-box btn btn-large btn-app icon-btn edit btn-sm " target="_blank" href="/CrystalReport/ContractListing.aspx?template=Reports/ContractListingRpt.rpt&periodNum=20150630 ">RPT</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div data-ng-show="totalPayments > 0" className="ws-12 box mtl">
                    <div className="ws-12 landing">
                        <table className="borderNone">
                            <thead>
                                <tr>
                                    <th className="notableBordered">Contact</th>
                                    <th className="notableBordered">Crossed Y/N</th>
                                    <th className="notableBordered">Min Payment</th>
                                    <th className="notableBordered">
                                        <span>Closing Balance</span>
                                    </th>
                                </tr>
                            </thead>
                        </table>
                        {paymentDetail?.map((values: any, index: any) => {
                            return (

                                <div className="bg-white ws-12 well cursor-hand m5">
                                    <table className="borderNone">
                                        <thead>
                                            <tr>
                                                <th className="notableBordered width400">
                                                    <h2>
                                                        <span className="purple ">{values?.kontactname} - {values?.kontactCode} [{values?.contracts?.length}]</span>
                                                    </h2>
                                                </th>

                                                <th className="notableBordered">
                                                    <div data-ng-hide="!filteredPayments[$indexK].showForm" className="ng-hide">
                                                        <label className="mr pull-left ">
                                                            Crossed
                                                            <input type="checkbox" data-ng-value="true" data-ng-change="generateTotalPayment($indexK)" name="crossPay[0]" value="true" />
                                                        </label>
                                                    </div>
                                                    <div data-ng-hide="filteredPayments[$indexK].showForm">
                                                        <button className="btn-sm icon-btn edit pull-left mr mll ">
                                                            Y
                                                        </button>
                                                        <button data-ng-hide="filteredPayments[$indexK]['contactCrossed']" className="pull-left mr btn-sm icon-btn delete mll ">
                                                            N
                                                        </button>
                                                    </div>
                                                </th>
                                                <th className="notableBordered">
                                                    <div data-ng-hide="!filteredPayments[$indexK].showForm" className="ng-hide">
                                                        <label font-mini="" className="form-condensed pull-left">
                                                            <input className="text-right ws-8 " type="text" data-ng-hide="!filteredPayments[$indexK].showForm" data-ng-model="filteredPayments[$indexK]['minPay']" />
                                                        </label>
                                                    </div>
                                                    <div data-ng-hide="filteredPayments[$indexK].showForm">
                                                        <label className="pull-right " title="0">
                                                            0.00
                                                        </label>
                                                    </div>
                                                </th>
                                                <th className="notableBordered text-right">
                                                    <label className="text-right ">
                                                        0.00
                                                    </label>
                                                </th>
                                                <th className="notableBordered">
                                                    <div className="form-condensed ws-12 m0 ml pull-right">
                                                        <div className="ws-4">
                                                            <input type="text" className="text-right text-bold ws-12 " ng-model="filteredPayments[$index]['payAllContract']" value={values.minPay} readOnly />
                                                        </div>
                                                        <div className="ws-3">
                                                            <button data-ng-click="saveAll($indexK)" className="btn-queue pull-right " ng-hide="saveTopLoading[$indexK]">
                                                                Pay all
                                                            </button>
                                                            <button className="btn-search pull-right" ng-show="saveTopLoading[$indexK]">
                                                                <i className="icon-spinner3"></i>
                                                            </button>
                                                        </div>

                                                        <div className="ws-3">
                                                            <a className="btn icon-btn delete pull-right btn-sm" title="Cancel" data-ng-click="cancelEditRow(filteredPayments[$indexK])" data-ng-hide="!filteredPayments[$indexK].showForm">
                                                                <i className="icon-close"></i>
                                                            </a>
                                                            <a className="btn icon-btn edit btn-sm pull-right" title="Edit" data-ng-click="editRow(filteredPayments[$indexK])" data-ng-show="!filteredPayments[$indexK].showForm">
                                                                <i className="icon-edit-pencil"></i>
                                                            </a>
                                                            <a className="btn icon-btn edit pull-right btn-sm" title="Save" data-ng-click="openConfirmationPopup($indexK);" data-ng-hide="!filteredPayments[$indexK].showForm">
                                                                <i className="icon-save"></i>
                                                            </a>
                                                        </div>
                                                        <div className="ws-2">

                                                            <button className="icon-btn info btn-sm pull-right pm">
                                                                <i className="text-s m0 icon-arrow"></i>
                                                            </button>
                                                        </div>
                                                    </div>

                                                </th>
                                            </tr>

                                        </thead>
                                    </table>

                                    <div className="box-content form-horizontal kng-fade p0 pl pt pb border-top hide"  >
                                        <div className="alert alert-danger hide"> Enter a payment for at least one contract </div>
                                        <div className="alert alert-success hide"> Payment done </div>
                                        <div className="alert alert-info hide"> No contracts found </div>

                                        <div className="table-responsive form-condensed p0 prs">
                                            <table className="borderNone notableBordered">
                                                <thead>
                                                    <tr>
                                                        <th className="notableBordered"></th>
                                                        <th className="text-right notableBordered ">Opening Balance</th>
                                                        <th className="text-right notableBordered ">Payments</th>
                                                        <th className="text-right notableBordered ">Period Bal</th>
                                                        <th className="text-right notableBordered ">Royalties</th>
                                                        <th className="text-right notableBordered"><span >Closing Balance</span></th>
                                                        <th className="notableBordered"><span>Payment toMake</span></th>
                                                        <th className="text-center notableBordered ">Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr className="border-bottom">

                                                        <td className="notableBordered">
                                                            <a ng-click="ROYContractWizard({contractRefNum : filteredPayments[$indexK]['allFilteredContracts'][$indexC]['contractRefNum']})" className="ws-12 mb text-bold " title="ROY Contract">
                                                                2025
                                                            </a>
                                                            <span title="MECHANICAL ACCOUNT WHERE NO CONTRACT" >
                                                                MECHANICAL ACCOUNT WHERE NO CONTRACT
                                                            </span>
                                                            <span data-ng-show="filteredPayments[$indexK]['allFilteredContracts'][$indexC]['contracttitle'].length &gt; 80" className="ng-hide">...</span>

                                                        </td>

                                                        <td className="text-right notableBordered border-right">
                                                            <span title="0" >
                                                                0.00

                                                            </span>

                                                            <input type="radio" className="pull-right ml " ng-click="filteredPayments[$indexK]['allFilteredContracts'][$indexC]['suggestedPayment'] = filteredPayments[$indexK]['allFilteredContracts'][$indexC]['openingBal']; changePayTotalOverall( filteredPayments[$indexK]['allFilteredContracts'][$indexC]['suggestedPayment'], $indexK, $indexC)" name="payBalT" ng-model="totalPayBal" />

                                                        </td>
                                                        <td className="text-right notableBordered border-right">
                                                            <div ng-controller="contract.indicatorController" ng-init="loadIndicatorData()" >
                                                                <span>
                                                                    <a href="javascript:void(0)" title="Payments Indicator" ng-click="openIndicator(contract, 'payments', contract.totalValue == 0, true);" >
                                                                        0.00
                                                                    </a>

                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td className="text-right notableBordered border-right">
                                                            <span title="0" >
                                                                0.00
                                                            </span>
                                                        </td>

                                                        <td className="text-right notableBordered border-right">
                                                            <span title="0" >
                                                                0.00
                                                            </span>
                                                        </td>

                                                        <td className="text-right notableBordered border-right">
                                                            <span title="0" ng-click="filteredPayments[$indexK]['allFilteredContracts'][$indexC]['suggestedPayment'] = filteredPayments[$indexK]['allFilteredContracts'][$indexC]['totalBal'] | currency : '' : 2" >
                                                                0.00
                                                            </span>
                                                            <input type="radio" className="pull-right ml " ng-click="filteredPayments[$indexK]['allFilteredContracts'][$indexC]['suggestedPayment'] = filteredPayments[$indexK]['allFilteredContracts'][$indexC]['totalBal']; changePayTotalOverall( filteredPayments[$indexK]['allFilteredContracts'][$indexC]['suggestedPayment'], $indexK, $indexC)" name="payBalT" ng-model="totalPayBal" />
                                                        </td>


                                                        <td className="ws-12 notableBordered">
                                                            <div className="w-55">
                                                                <input type="text" className="text-right ws-12 " ng-change="generatenNewTotalPayment($indexK, $indexC,'0')" ng-blur="ContractPaymentFormatting($indexK, $indexC)" ng-model="filteredPayments[$indexK]['allFilteredContracts'][$indexC]['suggestedPayment']" ng-value="filteredPayments[$indexK]['allFilteredContracts'][$indexC]['suggestedPayment']" value="0" />
                                                            </div>
                                                            <div className="ws-2 ml">
                                                                <a className="btn-queue " ng-click="openConfirmationPayIndividualPopup($indexK, $indexC, filteredPayments[$indexK]['allFilteredContracts'][$indexC]['detailDescription'], filteredPayments[$indexK]['allFilteredContracts'][$indexC]['suggestedPayment'])" ng-hide="payIndividualLoading[$indexK][$indexC]">
                                                                    Pay
                                                                </a>

                                                                <a className="btn-queue" ng-show="payIndividualLoading[$indexK][$indexC]">
                                                                    <i className="icon-spinner3"></i>
                                                                </a>
                                                            </div>

                                                        </td>
                                                        <td className="vertical hover-box text-center notableBordered">
                                                            <ul className="hover-block ws-2">
                                                                <li className="hover-box ws-12">
                                                                    <a className="icon-btn edit btn-sm ws-12 mb">Processed</a>
                                                                </li>
                                                                <li className="hover-box ws-12">
                                                                    <a className="icon-btn edit btn-sm ws-12 mb">Closed</a>
                                                                </li>
                                                                <li className="hover-box ws-12">
                                                                    <a className="btn-warning btn-sm ws-12 mb">Do not process</a>
                                                                </li>
                                                                <li className="hover-box ws-12">
                                                                    <a className="btn-info btn-sm ws-12 mb">Re-Open</a>
                                                                </li>
                                                                <li className="hover-box ws-12">
                                                                    <a className="btn-info btn-sm ws-12 mb">Unprocessed</a>
                                                                </li>
                                                            </ul>
                                                            <button className="btn icon-btn edit btn-sm">
                                                                Choose a status <span className="caret"></span>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                            )
                        })}
                    </div>

                </div>

            </div>
            {
                (() => {
                    if (suggestedPaymentUploadStatus) {
                        return <SuggestedPaymentUploadBox param={suggestedPaymentUploadStatus} />
                    }
                })()
            }
        </div>}
    </>
    )
}